
import {
  apiAiMealLists,
  apiAiMealAdd,
  apiAiMealEdit,
  apiAiMealDel,
} from "@/api/setting";

import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
@Component({
  components: {
    lsPagination,
    LsDialog,
    DatePicker,
  },
})
export default class SetMealList extends Vue {
  /** S Data **/

  apiAiMealLists = apiAiMealLists;

  pager: RequestPaging = new RequestPaging();

  searchObj: Object = {
    status: "",
    shop_info: "",
    start_time: "",
    end_time: "",
    type: 2,
  };
  id = 0;
  form: any = {
    price: "",
    to_integral: "",
    status: 1,
    sort: 1,
  };
  formDialogVisible = false;
  // 表单校验
  rules = {
    name: [{ required: true, message: "请输入套餐名称", trigger: "blur" }],
    to_integral: [{ required: true, message: "请输入积分", trigger: "blur" }],
    price: [{ required: true, message: "请输入单价", trigger: "blur" }],
  };
  /** E Data **/

  /** S Methods **/

  // 获取列表
  getLists(): void {
    this.pager.request({
      callback: apiAiMealLists,
      params: {
        ...this.searchObj,
      },
    });
  }

  handleAdd() {
    this.id = 0;
    this.form = {
      name: "",
      price: "",
      to_integral: "",
      status: 1,
      sort: 1,
    };
    this.formDialogVisible = true;
  }
  // 点击编辑
  async handleEdit(value: any) {
    this.id = value.id;
    this.form = {
      name: value.name, //
      price: value.price,
      status: value.status,
      sort: value.sort,
      to_integral: value.to_integral,
    };
    this.formDialogVisible = true;
  }

  async handleStatusChange(row: any) {
    this.form = {
      name: row.name, // 套餐名称
      price: row.price,
      status: row.status === 1 ? 0 : 1,
      sort: row.sort,
      to_integral: row.to_integral,
    };
    await apiAiMealEdit({ ...this.form, id: row.id });
    this.getLists();
  }

  async handleSortChange(event: any, row: any) {
    this.form = {
      name: row.name, // 套餐名称
      price: row.price,
      status: row.status === 1 ? 0 : 1,
      sort: row.sort,
      to_integral: row.to_integral,
    };
    row.sort = event;
    await apiAiMealEdit({ ...this.form, id: row.id });
    this.getLists();
  }

  // 删除
  async onSetMealDelete(row: any): Promise<void> {
    await apiAiMealDel({ id: row.id });
    this.getLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getLists();
  }

  // 添加
  async handleSetMealAdd(): Promise<void> {
    await apiAiMealAdd({ ...this.form });
    this.getLists();
  }

  //
  async handleSetMealEdit(): Promise<void> {
    await apiAiMealEdit({ ...this.form, id: this.id });
    this.getLists();
  }

  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement;
    refs.validate((valid: boolean): any => {
      if (!valid) return;

      if (!this.id) {
        this.handleSetMealAdd();
      } else {
        this.handleSetMealEdit();
      }
      this.formDialogVisible = false;
    });
  }

  /** E Methods **/

  /** S ods **/
  created() {
    this.getLists();
  }
}
